/* eslint-disable jsx-a11y/anchor-is-valid */
import { FunctionComponent, useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { useDispatch } from "react-redux";
import {
  ArtifactResponse,
  ArtifactsProps,
} from "../../../shared/interfaces/components/history-artifacts/historyArtifacts.interface";
import * as actions from "../../../store/historyArtifacts/action";
import PopperPopupState from "../../../shared/components/button/Popper";
import DownloadIcon from "@mui/icons-material/Download";
import {
  TableRow,
  TableCell,
  TableHead,
  Table,
  TableContainer,
  Paper,
  TablePagination,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import React from "react";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Popper from "@mui/material/Popper";
import PopupState, { bindToggle, bindPopper } from "material-ui-popup-state";
import Fade from "@mui/material/Fade";
import DeleteIcon from "@mui/icons-material/Delete";
import NewTablePdfCost from "../../../shared/components/NewTablePdfCost";
import GitlabModal from "../../modalLogin/GitlabModal";
import nexumspinner from "../../../assets/nexumspinner.gif";
import ContactForm from "../../ContactForm/ContactForm";
import { gtag, install } from "ga-gtag";
import Popup from "../../../shared/components/Alert/AlertPopUp";
import FileUploader from "../../../shared/components/UploaderJson/Uploaderjson";
import DescriptionAlerts from "../../../shared/components/Alert/AlertNotification";
import PopupVideo from "../../../shared/components/Alert/PopVideo";
import PopupAutoPilot from "../../../shared/components/Alert/PopAutoPilot";
import { Console } from "console";

// Google Analytics initializer
ReactGA.initialize("G-LBY0B19H81");
install("G-LBY0B19H81");

export const recoverResponseData = async (message: ArtifactResponse[]) => {
  responseData = message;
  let isLoading = true;
  responseData.length === 0 ? (isLoading = false) : (isLoading = true);
};

let responseData: ArtifactResponse[] = [];
const HistoryArtifacts: FunctionComponent<ArtifactsProps> = (data) => {
  // dispatch an action to get the history artifacts
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedType, setSelectedType] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState<ArtifactResponse[]>([]);
  const [showCost, setShowCost] = useState(false);
  const [showdiagram, setShowDiagram] = useState(false);
  const [isGitlabModalOpen, setIsGitlabModalOpen] = useState(false);
  const [load, setLoad] = useState(false);
  const [isEmailFormVisible, setIsEmailFormVisible] = useState(false);
  const [isTrial, setIsTrial] = useState(false);
  const [trialEnded, setTrialEnded] = useState(false);
  const [subscription, setSubscription] = useState("");
  const [dailyQuotaReached, setDailyQuotaReached] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [popVideo, setPopVideo] = useState(false);
  const allDeleted = responseData.every((item) => item.deleted);

  const [notification, setNotification] = useState<
    "success" | "info" | "warning" | "error"
  >("success");
  const [uploadSuccess, setUploadSuccess] = useState<boolean>(false);

  const provider = window.localStorage.getItem("provider");
  const storedShowAlert = window.localStorage.getItem("welcomeAlert");
  useEffect(() => {
    if (storedShowAlert === "true") {
      data.setShowAlert(true);
    } else data.setShowAlert(false);
  }, []);
  /* FOR SETTING THE TRIAL MODE */
  useEffect(() => {
    if (provider === "google") {
      setIsTrial(true);
    }
    ReactGA.set({ userId: window.sessionStorage.getItem("uid") });
  }, []);

  /* CONTROLL IF THEY ARE 5 RECORD WHEN IS TRIAL */
  useEffect(() => {
    const maxConversationTrial = process.env.REACT_APP_MAX_CONVERSATION_TRIAL ?? "";
    const maxConversationBasic = process.env.REACT_APP_MAX_CONVERSATION_BASIC ?? "";
    const maxConversationPro = process.env.REACT_APP_MAX_CONVERSATION_PRO ?? "";

    let subscription = "dev";
    let maxConversation = parseInt(maxConversationTrial);
    //all elements in filterdData have same subscription, so i just check the first one
    if (filteredData.length > 0) {
      if (filteredData[0].userSubscription !== undefined) {
        subscription = filteredData[0].userSubscription
        if (subscription === "Basic")
          maxConversation = parseInt(maxConversationBasic);
        if (subscription === "Pro")
          maxConversation = parseInt(maxConversationPro);
        if (subscription === "Enterprise")
          maxConversation = parseInt("100000");
      }
      
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const unixTimestampToday = Math.floor(today.getTime() / 1000);
      const filteredDataLength = filteredData.filter((item) => item.time._seconds > unixTimestampToday).length ?? 0;
      if (process.env.REACT_APP_IS_NGROK_ACTIVE === "true") {
        // developer access, no limitations
      } else {
        console.log(isTrial)
        if (isTrial === true && !trialEnded && filteredData.length >= maxConversation) {
          setIsEmailFormVisible(true);
          setTrialEnded(true);
          data.handleTrialEnded();
        }
        if (subscription === "Expired") {
          setIsEmailFormVisible(true);
          setTrialEnded(false);
          data.handleTrialEnded();
        }
        if (subscription === "Basic" && filteredDataLength >= maxConversation) {
          setIsEmailFormVisible(true);
          setTrialEnded(false);
          setDailyQuotaReached(true);
          data.handleTrialEnded();
        }
        if (subscription === "Pro" && filteredDataLength >= maxConversation) {
          setIsEmailFormVisible(true);
          setTrialEnded(false);
          setDailyQuotaReached(true);
          data.handleTrialEnded();
        }
      }
      setSubscription(subscription);
    }
  }, [filteredData, trialEnded, subscription, dailyQuotaReached]);

  /* CONTROLL AFTER 30 MIN WHEN IS TRIAL  */
  useEffect(() => {
    const alertTimeout = setTimeout(() => {
      setTrialEnded(true);
    }, 30 * 60 * 1000); // 30 min

    return () => clearTimeout(alertTimeout); // Pulisce il timeout quando il componente si smonta
  }, []);

  const toggleEmailFormVisibility = () => {
    setIsEmailFormVisible(!isEmailFormVisible);
    let uid = window.sessionStorage.getItem("uid");
    if (typeof uid !== "string") {
      uid = "null";
    }
    data.setContactFormOpen(!data.contactFormOpen);
  };

  // dispatch an action to get the history artifacts (mock)
  const getArtifactsFunction = () => {
    dispatch(actions.getArtifactsRequest(data));
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sendEvent = (metricName: string) => {
    let uid = window.sessionStorage.getItem("uid");
    let sid = window.sessionStorage.getItem("chatId");
    if (typeof uid !== "string") {
      uid = "null";
    }

    gtag("config", "G-LBY0B19H81", {
      custom_map: {
        dimension1: "UserId",
        dimension2: "SessionId",
        metric1: metricName,
      },
    });

    gtag("event", "buttonClicked", {
      UserId: uid,
      SessionId: sid,
      [metricName]: 1,
    });
  };

  const [order, setOrder] = useState<"asc" | "desc">("desc");
  const handleDateSort = () => {
    setOrder(order === "asc" ? "desc" : "asc");
  };

  function handleClick() {
    sessionStorage.clear();
    localStorage.clear();
    window.location.assign("/");
  }
  //-----------------------------Filtering---------------------------------------------
  useEffect(() => {
    //getArtifactsFunction()
    const filtered = responseData
      .filter((conv: ArtifactResponse) =>
        conv.conversation_id.toLowerCase().includes(searchValue.toLowerCase())
      )
      .filter(
        (conv: ArtifactResponse) =>
          selectedType === "" || conv.type === selectedType
      );
    setFilteredData(filtered);
  }, [responseData, searchValue, selectedType]);

  //-------------------------------Automatic Table Loading------------------------------
  const refreshTableData = () => {
    dispatch(actions.getArtifactsRequest(data));
  };

  useEffect(() => {
    refreshTableData();
    const intervalId = setInterval(refreshTableData, 10000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const newElements = responseData.slice(filteredData.length);
    if (newElements.length > 0) {
    }
  }, [responseData, filteredData]);

  //-------------------------API Delete--------------------------------------------------

  const onSubmitconversation = (id: string) => {
    setLoad(true);
    const conv = filteredData.find((conv) => conv.conversation_id === id);

    if (!conv) {
      console.error(`Conversation with ID ${id} not found`);
      return;
    }
    //--FOR DELETE IN LOCAL SESSION-----------------
    //const convUrl = `${process.env.REACT_APP_API_BASE_URL}/conversation/delete/`;

    //--FOR DELETE IN DEPLOYED SESSION-----------------
    const convUrl = `${process.env.REACT_APP_API_BASE_URL}/conversation/delete/`;
    const uid =
      window.sessionStorage.getItem("uid") === null
        ? "JEVZyG7f36S8BPNE6kSTryos43t1"
        : window.sessionStorage.getItem("uid");

    axios
      .post(convUrl, { conversation_id: conv.conversation_id, uid: uid })
      .then(
        (response) => {
          setLoad(false);
          refreshTableData();
        },
        (error) => {
          setLoad(false);
        }
      );
  };

  //---------------------------DELETE ALL --------------------------------------------------
  const handleDeleteAll = () => {
    setLoad(true);
    const conversationIdsToDelete = responseData
      .filter((item) => !item.deleted)
      .map((item) => item.conversation_id);

    //--FOR DELETE IN DEPLOYED SESSION-----------------
    const convUrl = `${process.env.REACT_APP_API_BASE_URL}/conversation/delete/`;
    const uid =
      window.sessionStorage.getItem("uid") === null
        ? "JEVZyG7f36S8BPNE6kSTryos43t1"
        : window.sessionStorage.getItem("uid");

    axios
      .post(convUrl, { conversation_id: conversationIdsToDelete, uid: uid })
      .then(
        (response) => {
          setLoad(false);
          refreshTableData();
        },
        (error) => {
          setLoad(false);
        }
      );
  };

  const handleCloseAlert = () => {
    window.localStorage.setItem("welcomeAlert", "false");
    data.setShowAlert(false);
    refreshTableData();
  };
  const handleUpload = (file: File) => {
    data.setDisableChatbot(true);
    setLoad(true);
    setShowUploadModal(false);
    const formData = new FormData();
    formData.append("file", file);

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/declarative_approach/gcs/sa/upload`,
        formData
      )
      .then((response) => {
        setNotification("success");
        setUploadSuccess(true);
        setTimeout(() => {
          data.setDisableChatbot(false);
          setLoad(false);
          setShowUploadModal(false);
          setUploadSuccess(false);
        }, 2000);
      })
      .catch((error) => {
        setUploadSuccess(true);
        setNotification("error");
        setTimeout(() => {
          setLoad(false);
          data.setDisableChatbot(false);
          setUploadSuccess(false);
          setShowUploadModal(true);
        }, 2000);
        console.error("Error uploading file:", error);
      });
  };

  const handleCloseModal = () => {
    setShowUploadModal(false);
  };
  const handleShow = () => {
    setPopVideo(true);
    data.setShowVideo(true);
  };
  const handleShowClose = () => {
    setPopVideo(false);
    data.setShowVideo(false);
  };

  return (
    <>
      {uploadSuccess && (
        <DescriptionAlerts
          severity={notification}
          uploadSuccess={uploadSuccess}
        />
      )}
      <div>
        {showUploadModal && (
          <FileUploader
            onFileUpload={handleUpload}
            onClose={handleCloseModal}
          />
        )}
      </div>
      {load === true && (
        <div className="cardLoading">
          <img alt="loading" className="loadingDelete" src={nexumspinner} />
        </div>
      )}
      <div>
        <GitlabModal
          isOpen={isGitlabModalOpen}
          onClose={() => setIsGitlabModalOpen(false)}
        />
        {storedShowAlert === "true" ? (
          <Popup
            message={
              <div style={{ textAlign: "center" }}>
                <h4>
                  Welcome to{" "}
                  <span style={{ color: "rgb(41, 73, 146)" }}>Nexbot</span>,
                  your personal cloud architect. <br />
                  Some extensions can interfere with Nexbot.
                  <br /> If installed, disable the following browser extensions
                  to take full advantage of its features: &nbsp;
                  <span style={{ color: "red" }}>Privacy badger</span>
                </h4>
              </div>
            }
            onClose={handleCloseAlert}
          />
        ) : popVideo ? (
          <PopupVideo
            message={<div style={{ textAlign: "center" }}></div>}
            onClose={handleShowClose}
          />
        ) : data.showAutoPilot ? (
          <PopupAutoPilot
            setShowAutoPilot={data.setShowAutoPilot}
            startAutoPilot={data.startAutoPilot}
            setStartAutoPilot={data.setStartAutoPilot}
            message={<div></div>}
            onClose={() => data.setShowAutoPilot(false)}
          />
        ) : (
          <div style={{ display: "-webkit-box" }}>
            <div className="card">
              <>
                <div>
                  <div style={{ display: "inline-flex", width: "25em" }}>
                    <button
                      disabled={load}
                      onClick={() => {
                        handleClick();
                        sendEvent("button_logout");
                      }}
                      className={`Btn ${load ? "disabled" : ""}`}
                    >
                      <div className="sign">
                        <svg viewBox="0 0 512 512">
                          <path
                            style={{ fill: "white" }}
                            d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                          ></path>
                        </svg>
                      </div>

                      <div className="text">Logout</div>
                    </button>
                    {!isEmailFormVisible && (
                      <button
                        className={`buttondiagram ${
                          showdiagram || showCost || load ? "disabled" : ""
                        }`}
                        onClick={() => {
                          toggleEmailFormVisibility();
                          sendEvent("button_contactus");
                        }}
                        onBlur={(e) => e.target.blur()}
                        disabled={showdiagram || showCost || load}
                      >
                        Contact us
                      </button>
                    )}
                  </div>
                  {!isEmailFormVisible && (
                    <div
                      style={
                        !showdiagram && !showCost
                          ? {
                              display: "flex",
                              marginLeft: "57.5%",
                              marginTop: "-4%",
                              marginBottom: "1%",
                            }
                          : showdiagram && !showCost
                          ? {
                              display: "flex",
                              marginLeft: "57.5%",
                              marginTop: "-4%",
                              marginBottom: "1%",
                            }
                          : showCost && !showdiagram
                          ? {
                              display: "flex",
                              marginLeft: "55.5%",
                              marginTop: "-4%",
                              marginBottom: "1%",
                            }
                          : {}
                      }
                    >
                      <button
                        disabled={load}
                        className={`buttondiagram ${load ? "disabled" : ""}`}
                        onClick={() => handleShow()}
                      >
                        Demo
                      </button>
                      <button
                        disabled={load}
                        className={`buttondiagram ${load ? "disabled" : ""}`}
                        onClick={() => setShowUploadModal(true)}
                      >
                        Upload to GCS
                      </button>
                      <button
                        disabled={load}
                        onClick={() => {
                          sendEvent("button_gitlabinfo");
                          setIsGitlabModalOpen(true);
                        }}
                        className={`buttondiagram ${load ? "disabled" : ""}`}
                      >
                        Gitlab info
                      </button>
                      <button
                        disabled={load}
                        className={`buttondiagram ${load ? "disabled" : ""}`}
                        onClick={() => {
                          if (showdiagram) {
                            sendEvent("button_historyartifact");
                            setShowDiagram(false);
                            setShowCost(false);
                          } else {
                            sendEvent("button_showdiagram");
                            setShowDiagram(true);
                            setShowCost(false);
                          }
                        }}
                      >
                        {!showdiagram ? "Show diagram" : "History Artifact"}
                      </button>
                      <button
                        disabled={load}
                        className={`buttondiagram ${load ? "disabled" : ""}`}
                        onClick={() => {
                          if (showCost) {
                            sendEvent("button_historyartifact");
                            setShowDiagram(false);
                            setShowCost(false);
                          } else {
                            sendEvent("button_tablecost");
                            setShowDiagram(false);
                            setShowCost(true);
                          }
                        }}
                      >
                        {!showCost ? "Table Cost" : "History Artifact"}
                      </button>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    zIndex: "3",
                    display: "flex",
                    width: "99%",
                    justifyContent: "end",
                  }}
                >
                  {!isEmailFormVisible && (
                    <svg
                      style={{
                        position: "absolute",
                        marginLeft: "94%",
                        marginTop: "9px",
                        zIndex: "4",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="20"
                      height="20"
                      viewBox="0,0,256,256"
                    >
                      <g
                        fill="#cccccc"
                        fill-rule="nonzero"
                        stroke="none"
                        stroke-width="1"
                        stroke-linecap="butt"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                        stroke-dasharray=""
                        stroke-dashoffset="0"
                        font-family="none"
                        font-weight="none"
                        font-size="none"
                        text-anchor="none"
                      >
                        <g transform="scale(8.53333,8.53333)">
                          <path d="M13,3c-5.511,0 -10,4.489 -10,10c0,5.511 4.489,10 10,10c2.39651,0 4.59738,-0.85101 6.32227,-2.26367l5.9707,5.9707c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-5.9707,-5.9707c1.41266,-1.72488 2.26367,-3.92576 2.26367,-6.32227c0,-5.511 -4.489,-10 -10,-10zM13,5c4.43012,0 8,3.56988 8,8c0,4.43012 -3.56988,8 -8,8c-4.43012,0 -8,-3.56988 -8,-8c0,-4.43012 3.56988,-8 8,-8z"></path>
                        </g>
                      </g>
                    </svg>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "99%",
                    marginBottom: "1em",
                  }}
                >
                  {!isEmailFormVisible && (
                    <div className="menutitle">
                      {showdiagram && !showCost ? (
                        <h4 className="card__header--title ml-2 flex-grow-1 ">
                          Diagram
                        </h4>
                      ) : !showdiagram && showCost ? (
                        <h4 className="card__header--title ml-2 flex-grow-1 ">
                          Table Cost
                        </h4>
                      ) : !showdiagram && !showCost ? (
                        <h4 className="card__header--title ml-2 flex-grow-1 ">
                          History artifact
                        </h4>
                      ) : null}
                    </div>
                  )}

                  <div
                    style={
                      !showCost && !showdiagram
                        ? {
                            display: "flex",
                            zIndex: "0",
                            marginLeft: "57%",
                            height: "auto",
                          }
                        : showCost && !showdiagram
                        ? {
                            display: "flex",
                            zIndex: "0",
                            marginLeft: "60%",
                            height: "auto",
                          }
                        : !showCost && showdiagram
                        ? {
                            display: "flex",
                            zIndex: "0",
                            marginLeft: "62%",
                            height: "auto",
                          }
                        : {}
                    }
                  >
                    {!isEmailFormVisible && (
                      <input
                        disabled={load}
                        style={{ paddingLeft: "1em" }}
                        className={`menuhead ${load ? "disabled" : ""}`}
                        type="search"
                        placeholder={"Search by Name..."}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                    )}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "99%",
                      marginBottom: "1em",
                    }}
                  >
                    <div
                      style={
                        !showCost && !showdiagram
                          ? {
                              display: "flex",
                              zIndex: "0",
                              marginLeft: "68.5%",
                              height: "auto",
                            }
                          : showCost && !showdiagram
                          ? {
                              display: "flex",
                              zIndex: "0",
                              marginLeft: "71.2%",
                              height: "auto",
                            }
                          : !showCost && showdiagram
                          ? {
                              display: "flex",
                              zIndex: "0",
                              marginLeft: "73.8%",
                              height: "auto",
                            }
                          : {}
                      }
                    ></div>
                  </div>
                </div>

                {/* Start Body of the table */}
                {getArtifactsFunction}

                {showCost ? (
                  <NewTablePdfCost />
                ) : showdiagram ? (
                  <PopperPopupState />
                ) : isEmailFormVisible ? (
                  <ContactForm
                    trialEnded={trialEnded}
                    isTrial={isTrial}
                    setIsEmailFormVisible={setIsEmailFormVisible}
                    setContactFormOpen={data.setContactFormOpen}
                    subscription={subscription}
                    dailyQuotaReached={dailyQuotaReached}
                  />
                ) : (
                  <Paper>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell className="textmenu">
                              <b>Name</b>
                            </TableCell>
                            <TableCell className="textmenu">
                              <b>Status</b>
                            </TableCell>
                            <TableCell className="textmenu">
                              <select
                                style={{ border: "none", fontWeight: "bold" }}
                                onChange={(e) =>
                                  setSelectedType(e.target.value)
                                }
                              >
                                <option value="">Type...</option>
                                <option value="imperative">imperative</option>
                                <option value="declarative">declarative</option>
                              </select>
                            </TableCell>
                            <TableCell
                              className="textmenu"
                              onClick={handleDateSort}
                            >
                              <b>Date {order === "asc" ? "▲" : "▼"}</b>
                            </TableCell>
                            <TableCell className="textmenu">
                              <b>Cost</b>
                            </TableCell>
                            <TableCell className="textmenu">
                              <b>Diagram</b>
                            </TableCell>
                            { filteredData.filter(val => val.status === "completed" && val.config_file.length > 0).length > 0 && isTrial === false ?
                              <TableCell className="textmenu">
                              <b>Config</b>
                            </TableCell> : <TableCell></TableCell>
                            }
                            <TableCell className="textmenu">
                              <PopupState
                                variant="popper"
                                popupId="demo-popup-popper"
                              >
                                {(popupState) => (
                                  <div>
                                    <button
                                      disabled={allDeleted}
                                      {...bindToggle(popupState)}
                                      className={`ButtonDeleteAll ${
                                        allDeleted || load ? "disabled" : ""
                                      }`}
                                    >
                                      Delete All
                                    </button>
                                    <Popper
                                      {...bindPopper(popupState)}
                                      transition
                                    >
                                      {({ TransitionProps }) => (
                                        <Fade
                                          {...TransitionProps}
                                          timeout={350}
                                        >
                                          <Paper>
                                            <Typography sx={{ p: 2 }}>
                                              <b>
                                                Really Do you want delete all
                                                conversations?
                                              </b>
                                            </Typography>
                                            <div
                                              style={{
                                                marginLeft: "28%",
                                                paddingBottom: "5%",
                                              }}
                                            >
                                              <button
                                                className="deleteButton"
                                                onClick={() => {
                                                  sendEvent(
                                                    "button_internal_delete"
                                                  );
                                                  handleDeleteAll();
                                                  refreshTableData();
                                                  popupState.close();
                                                }}
                                              >
                                                Yes
                                              </button>
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                              <button
                                                className="deleteButton"
                                                {...bindToggle(popupState)}
                                              >
                                                No
                                              </button>
                                            </div>{" "}
                                          </Paper>
                                        </Fade>
                                      )}
                                    </Popper>
                                  </div>
                                )}
                              </PopupState>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {filteredData.length === 0 && (
                          <div className="row card__body--table">
                            <div className="col-xs-12">
                              <h5 className="card__header--title">
                                <br />
                                No Conversations
                              </h5>
                            </div>
                          </div>
                        )}
                        {filteredData.length !== 0 &&
                          filteredData
                            .filter((conv: ArtifactResponse) =>
                              conv.conversation_id
                                .toLowerCase()
                                .includes(searchValue.toLowerCase())
                            )
                            .filter(
                              (conv: ArtifactResponse) =>
                                selectedType === "" ||
                                conv.type === selectedType
                            )
                            .filter((conv: ArtifactResponse) => !conv.deleted)
                            .sort(
                              (a: ArtifactResponse, b: ArtifactResponse) => {
                                const dateA = new Date(a.time._seconds * 1000);
                                const dateB = new Date(b.time._seconds * 1000);
                                return order === "asc"
                                  ? dateA.getTime() - dateB.getTime()
                                  : dateB.getTime() - dateA.getTime();
                              }
                            )
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((conv: ArtifactResponse) => (
                              <TableRow key={conv.conversation_name}>
                                <TableCell>
                                  <b>{conv.conversation_name}</b>
                                </TableCell>
                                <TableCell>
                                  {/* {conv.type === "guided" ? "final" : "no status"} */}
                                  {conv.status}
                                </TableCell>
                                <TableCell>{conv.type}</TableCell>
                                <TableCell>
                                  {new Date(
                                    conv.time._seconds * 1000 -
                                      1 * 60 * 60 * 1000
                                  ).toLocaleString()}
                                </TableCell>
                                <TableCell>
                                  {conv.status === "completed" && !load ? (
                                    <a href={conv.cost}>
                                      <AttachFileIcon
                                        className="icon"
                                        onClick={() => {
                                          sendEvent("button_internal_cost");
                                        }}
                                      />
                                    </a>
                                  ) : (
                                    <AttachFileIcon className="icon" />
                                  )}
                                </TableCell>
                                <TableCell>
                                  {load ? (
                                    <AttachFileIcon className="icon" />
                                  ) : (
                                    <a href={conv.diagram} target="_blank">
                                      <AttachFileIcon
                                        className="icon"
                                        onClick={() => {
                                          sendEvent("button_internal_diagram");
                                        }}
                                      />
                                    </a>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {(() => {
                                    if (isTrial) {
                                      return null;
                                    }
                                    
                                    if (conv.status === "completed" && conv.config_file.length > 0) {
                                      return (
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault(); 
                                            sendEvent("button_internal_config");

                                            const downloadFile = (url: string, delay: number | undefined) => {
                                              return new Promise<void>((resolve) => {
                                                setTimeout(() => {
                                                  const anchor = document.createElement("a");
                                                  anchor.href = url;
                                                  anchor.download = ""; 
                                                  document.body.appendChild(anchor);
                                                  anchor.click();
                                                  document.body.removeChild(anchor); 
                                                  resolve(); 
                                                }, delay);
                                              });
                                            };

                                            const downloadFilesSequentially = async () => {
                                              for (let i = 0; i < conv.config_file.length; i++) {
                                                await downloadFile(conv.config_file[i], 500);
                                              }
                                            };

                                            downloadFilesSequentially();
                                          }}
                                        >
                                          <DownloadIcon className="icon" />
                                        </a>
                                      );
                                    }
                                    return <DownloadIcon className="disabled" />;
                                  })()}
                                </TableCell>
                                {/* <TableCell>
                                  {conv.status === "completed" &&
                                  conv.config_file.length > 0 ? (
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        sendEvent("button_internal_config");
                                        e.preventDefault();
                                        const openFilesWithInterval = () => {
                                          let index = 0;
                                          const intervalId = setInterval(() => {
                                            if (
                                              index < conv.config_file.length
                                            ) {
                                              window.open(
                                                conv.config_file[index],
                                                "_blank",
                                                "noopener,noreferrer"
                                              );
                                              index++;
                                            } else {
                                              clearInterval(intervalId);
                                            }
                                          }, 500);
                                        };
                                        openFilesWithInterval();
                                      }}
                                    >
                                      <DownloadIcon className="icon" />
                                    </a>
                                  ) : (
                                    <DownloadIcon className="icon" />
                                  )}
                                </TableCell> */}
                                <TableCell>
                                  {load ? (
                                    <DeleteIcon className="icon" />
                                  ) : (
                                    <a>
                                      <PopupState
                                        variant="popper"
                                        popupId="demo-popup-popper"
                                      >
                                        {(popupState) => (
                                          <div>
                                            <DeleteIcon
                                              {...bindToggle(popupState)}
                                              className="icon"
                                              style={{ cursor: "pointer" }}
                                            />

                                            <Popper
                                              {...bindPopper(popupState)}
                                              transition
                                            >
                                              {({ TransitionProps }) => (
                                                <Fade
                                                  {...TransitionProps}
                                                  timeout={350}
                                                >
                                                  <Paper>
                                                    <Typography sx={{ p: 2 }}>
                                                      <b>
                                                        Really Do you want
                                                        delete this
                                                        conversation?
                                                      </b>
                                                    </Typography>
                                                    <div
                                                      style={{
                                                        marginLeft: "28%",
                                                        paddingBottom: "5%",
                                                      }}
                                                    >
                                                      <button
                                                        className="deleteButton"
                                                        onClick={() => {
                                                          sendEvent(
                                                            "button_internal_delete"
                                                          );
                                                          onSubmitconversation(
                                                            conv.conversation_id
                                                          );
                                                          refreshTableData();
                                                          popupState.close();
                                                        }}
                                                      >
                                                        Yes
                                                      </button>
                                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                      <button
                                                        className="deleteButton"
                                                        {...bindToggle(
                                                          popupState
                                                        )}
                                                      >
                                                        No
                                                      </button>
                                                    </div>{" "}
                                                  </Paper>
                                                </Fade>
                                              )}
                                            </Popper>
                                          </div>
                                        )}
                                      </PopupState>
                                    </a>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                      </Table>

                      {/* --------------Button For Refresh The Table-------------- */}
                      {/* <button onClick={refreshTableData}>Refresh Data</button> */}
                    </TableContainer>
                    {responseData !== undefined && (
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={
                          responseData.filter((item) => !item.deleted).length
                        }
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    )}
                  </Paper>
                )}
              </>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HistoryArtifacts;
